export {
  ASSIGNMENT_MODE,
  currentAssignmentMode,
} from "./currentAssignmentMode";
